export default {
  namespaced: true,
  state: {
    verificationCondition: null, // 国际机票常旅身份验证
  },
  mutations: {
    setVerificationCondition(state, data) {
      state.verificationCondition = data;
    },
  },
  actions: {},
};
